import { MockAuthenticationGuard } from "services/auth/authmock/authentication-guard";
import { useMockAuth } from "services/auth/authmock/hooks";
import { MockProviderComponent } from "services/auth/authmock/provider";

export const mockAuthService = {
    useAuthHook: useMockAuth,
    AuthProviderComponent: MockProviderComponent,
    AuthenticationGuard: MockAuthenticationGuard,
}